import { render } from "./CardMessage.vue?vue&type=template&id=64035a11"
import script from "./CardMessage.vue?vue&type=script&lang=js"
export * from "./CardMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__